import React from "react";
import { View, Text, TextInput, Icon } from "ui";
import { styled, theme } from "styles";
import { Alert, Memo, AlertTemplate, User } from "types";
import moment from "moment";
import { SERVER_TIME_FORMAT, TIME_FORMAT, DATE_FORMAT } from "shared/constants";
import { Link } from "react-router-dom";
import { stringify } from "query-string";
import { isAlertExpired, getAlertDaysDiff } from "../pages/alertList/util";
import MemoAlertSimpleCreate from "./MemoAlertSimpleCreate";
import { RouteComponentProps, withRouter } from "react-router";

interface P {
  memo: Memo;
  alert?: Alert;
  template?: AlertTemplate;
  user: User;
  onClick?: () => void;
}

const MemoAlert = ({ alert, memo, template, user, history }: P & RouteComponentProps) => {
  const isExpired = isAlertExpired(alert);
  const daysDiff = getAlertDaysDiff(alert);

  let url;
  if (alert) {
    url = `/app/memos/${memo.id}/alert/${alert.id}`;
  } else {
    let query = {
      memo: memo.id
    } as any;
    if (template) {
      query.template = template.id;
    }
    url = `/app/memos/${memo.id}/alert?${stringify(query)}`;
  }
  return (
    <AlertCard
      m={1}
      bg="white"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      pl={2}
      pr={1}
      to={url}
      onClick={() => {
        if (!alert) {
          window.scroll({ top: 0, behavior: "smooth" });
        }
        history.push(url);
      }}
    >
      <View flex={10} flexDirection="column">
        <Title color="black" fontSize={4}>
          {alert && alert.name}
          {template && template.name}
        </Title>
        <View flexDirection="row" my={1}>
          <AlertsView
            bg="white"
            p={1}
            px={2}
            borderRadius={10}
            alignItems="center"
            mr={2}
            justifyContent="flex-start"
          >
            <Icon name="bell" size={1.5} color="black" />
            {!!daysDiff && (
              <Text
                ml={1}
                fontSize={2}
                color={isExpired ? "warning" : "primary"}
              >
                {daysDiff === 1 ? " o zi" : " " + daysDiff + " zile"}
              </Text>
            )}
          </AlertsView>

          <AlertsView
            bg="white"
            p={1}
            px={2}
            borderRadius={10}
            alignItems="center"
            mr={2}
            justifyContent="flex-start"
          >
            <Icon name="clock" size={1.5} color="black" />
            <Text ml={1} fontSize={2} color={isExpired ? "warning" : "primary"}>
              {alert &&
                moment
                  .utc(alert.first_alert_time, SERVER_TIME_FORMAT)
                  .local(false)
                  .format(TIME_FORMAT)}
            </Text>
          </AlertsView>

          <AlertsView
            bg="white"
            p={1}
            px={2}
            borderRadius={10}
            alignItems="center"
            mr={2}
            justifyContent="flex-start"
          >
            <Icon name="clock" size={1.5} color="black" />
            <Text ml={1} fontSize={2} color={isExpired ? "warning" : "primary"}>
              {alert &&
                moment
                  .utc(alert.second_alert_time, SERVER_TIME_FORMAT)
                  .local(false)
                  .format(TIME_FORMAT)}
            </Text>
          </AlertsView>
        </View>
      </View>
      <Date
        bg={isExpired ? "warning" : "primary"}
        borderRadius={10}
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        m={1}
      >
        {alert && (
          <Text color="white" fontSize={2}>
            {moment(alert.end_date, DATE_FORMAT).format("DD MMM YYYY")}
          </Text>
        )}
        {!alert && (
          <MemoAlertSimpleCreate
            memo_id={memo.id}
            alert_template_id={template.id}
            user={user}
          />
        )}
      </Date>
    </AlertCard>
  );
};

const Title = styled(Text)`
  font-weight: bold;
`;

const AlertsView = styled(View)`
  font-weight: bold;
  box-shadow: 0px 3px 3px grey;
  min-width: 5rem;
  min-height: 2rem;
`;

const AlertCard = styled(View)`
  box-shadow: 0px 5px 5px grey;
  cursor: pointer;
  text-decoration: none;
  color: ${theme.colors.primary};
` as any;

const Date = styled(View)`
  width: 5rem;
  height: 5rem;
  text-align: center;
  font-weight: bold;
`;

export default withRouter(MemoAlert);



// WEBPACK FOOTER //
// ./src/components/MemoAlert.tsx